import React from 'react'
import AllDiscountProductListContainer from '../../../../../Components/DiscountPart/DiscountListsContainer/AllDiscountProductListContainer/AllDiscountProductListContainer'
import Layout from '../../../Layout'

const AllProductDiscountList = () => {
  return (
    <Layout><AllDiscountProductListContainer/></Layout>
  )
}

export default AllProductDiscountList